import React, { Component } from 'react';
import Navbar from "../accueil/navbar/Navbar";
import Footer from '../accueil/footer/Footer';
import './mentions.css'
import '../scroll/Scroll.css'

class Mentions extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
        document.addEventListener('DOMContentLoaded', function () {
            window.onscroll = function (ev) {
                document.getElementById("cRetour").className = (window.pageYOffset > 100) ? "cVisible" : "cInvisible";
            };
        });
    }

    render() {
        return (
            <div id="haut" className="sticky-wrap">
                <Navbar />
                <div className="column align-items-center">
                    <div className="block-page-mentions">

                        <div className="block-title-mentions">
                            <h2 className="center-size-title">Conditions générales d'utilisation</h2>
                        </div>


                        <h3 className="title-section-block">Propriété intellectuelle et droit d'utilisation</h3>

                        <p>Le contenu de ce site est protégé par la propriété littéraire et artistique, la convention de
                            Berne et le code de la propriété intellectuelle, Livre I. Toute reproduction, autrement que
                            pour l'usage privé de l'utilisateur du site en vue notamment d'une diffusion publique par
                            n'importe quel moyen est strictement interdite sans l'autorisation préalable et écrite du
                                        webmaster du site.</p>
                        <p>
                            Toute représentation, modification, publication, transmission, dénaturation totale ou partielle du site ou de son contenu,
                            par quelques procédés que ce soit et sur quelque support que ce soit est interdite.
                             Toute exploitation non autorisée du site ou de son contenu, des informations qui y sont divulguées engagerait la responsabilité
                              de l'utilisateur et constituerait une contrefaçon sanctionnée par les articles L 335-2 et suivants du Code de la Propriété
                               Intellectuelle. Il en est de même des bases de données figurant, le cas échéant, sur le site Internet de l'éditeur qui est
                                protégé par les dispositions de la loi du 1er juillet 1998 portant transposition dans le Code de la Propriété Intellectuelle
                                 de la Directive Européenne du 11 mars 1996 relative à la protection juridique des bases de données. A ce titre,
                                             toute reproduction ou extraction engagerait la responsabilité de l'utilisateur.</p>
                        <p>
                            Les marques de l'éditeur ainsi que les logos figurant sur le site sont protégés. Toute
                            reproduction ou représentation totale ou partielle de ces marques ou de ces logos, seules ou
                            intégrées à d'autres éléments sans l'autorisation expresse et préalable de l'éditeur est
                                        prohibée et engagerait la responsabilité de l'utilisateur au sens des articles L 713-2 et L 713-3 du Code de la Propriété Intellectuelle.</p><p>
                            L'utilisateur s'engage, sous peine de voir sa responsabilité civile et/ ou pénale engagée, à ne
                                        pas utiliser le site Internet de l'éditeur pour:</p>

                        <p>
                            -  transmettre par quelques procédés que ce soit (e-mail ou autres), tout contenu incluant des programmes,
                                         des codes, des virus etc, destinés à détruire ou limiter les fonctionnalités du site Internet de l'éditeur.</p>
                        <p>
                            - transmettre par quelque procédé que ce soit (e-mail ou autres) dans les services
                            interactifs proposés sur le site Internet de l'éditeur, tout contenu illicite ou nuisible,
                            et notamment des messages à caractère injurieux, insultant, diffamant, dénigrant,
                            dégradant, raciste, xénophobe, sexiste, pornographique, menaçant ou qui pourrait
                            inciter à la haine ou au harcèlement et qui irait à l'encontre du droit au respect de
                                        la vie privée ou sans rapport avec les thèmes proposés,</p>
                        <p>
                            - transmettre par quelques procédés que ce soit, tout contenu violant les droits de la propriété intellectuelle,
                            industrielle, les droits de la personne, etc. L'éditeur se réserve la faculté, dans le cadre de ses services interactifs,
                            de supprimer immédiatement et sans mise en demeure préalable, tout contenu de quelque nature que ce soit,
                             et notamment tout message, texte, image graphisme,
                             etc. Qui contreviendrait aux lois et règlements en vigueur et notamment les réglementations décrites ci-dessus.
                              Dans l'hypothèse où un utilisateur souhaiterait utiliser un des contenus du site (texte, image, etc.),
                                          il s'engage à requérir l'autorisation préalable et écrite de l'éditeur en envoyant un courriel au webmaster à l'adresse suivante : <a href="mailto:staff@wildcodeschool.fr">Wild code school</a>
                        </p>



                        <h3 className="title-section-block">Droit applicable</h3>

                        <p>
                            Les présentes conditions générales sont soumises au droit interne français. La langue des
                            conditions générales est la langue française. En cas de litige, les tribunaux français seront
                            seuls compétents. L'éditeur se réserve le droit de modifier et mettre à jour à tout moment
                            l'accès au site ainsi que les présentes conditions générales. Ces modifications et mises à jour
                            s'imposent à l'utilisateur qui doit en conséquence se référer régulièrement à cette rubrique
                                        pour vérifier les conditions générales en vigueur.</p>



                        <h3 className="title-section-block">Informations contenues sur le site</h3>

                        <p>
                            Les documents et informations que l'éditeur diffuse en version électronique sur ce site font l'objet de nombreuses relectures ;
                             ils peuvent toutefois contenir des erreurs. Si vous en constatez, n'hésitez pas à le faire savoir en contactant
                             le webmaster de ce site, afin qu'il soit procédé aux rectifications correspondantes. Les informations communiquées sur ce site
                             sont fournies à titre indicatif, elles sont non-contractuelles et ne sauraient pas engager la responsabilité de l'éditeur.
                             Elles peuvent être modifiées ou mises à jour sans préavis. L'éditeur se réserve également le droit, à tout moment et sans préavis,
                                        d'apporter des améliorations et/ou modifications au site https://www.hermand-geometre.fr</p>
                        <p>
                            L'éditeur ne saurait pas être tenu responsable d'éventuels dommages directs ou indirects pouvant
                            découler de l'accès ou utilisation de ce site, ou d'un dommage ou virus qui pourrait affecter
                            l'ordinateur ou autre matériel informatique de l'utilisateur. Plus généralement l'éditeur
                                        n'assure aucune garantie, expresse ou tacite, concernant tout, ou partie, du site.</p>



                        <h3 className="title-section-block">Respect de la réglementation informatique et libertés par l'utilisateur du site</h3>

                        <p>
                            L'utilisateur doit s'abstenir, s'agissant des données à caractère personnel auxquelles il
                            accède, de toute collecte, de toute utilisation détournée et d'une manière générale de tout acte
                                        susceptible de porter atteinte à la vie privée ou à la réputation des personnes.</p>



                        <h3 className="title-section-block">Exercice des droits d'accès,de rectification et d'opposition à figurer dans un traitement informatique</h3>

                        <p>
                            L'utilisateur du site est informé que : Il dispose, conformément à la loi n°78-17 du 6 janvier
                            1978 (modifiée par la loi n°2004-801 du 6 Août 2004) et son décret d'application n°2005-
                            1309 du 20 octobre 2005 (modifié par le décret n°2007-451 du 25 mars 2007), de droits
                            d'accès, de rectification et d'opposition sur les données le concernant. Pour toute question ou
                                        réclamation, merci d'envoyer un mail au webmaster du site.</p>



                        <h3 className="title-section-block">Liens hypertextes</h3>

                        <p>
                            Les liens hypertextes mis en place dans le cadre de ce site en direction d'autres sites Internet
                            ont fait l'objet d'une autorisation préalable et expresse. Toutefois, l'éditeur n'étant pas
                            l'éditeur de ces sites, il ne peut en contrôler le contenu. En conséquence, l'éditeur ne pourra
                            en aucun cas être tenu pour responsable du contenu des sites ainsi accessibles, ou
                            d'éventuelles collectes et transmission de données personnelles, installation de cookies ou
                            tout autre procédé tendant aux mêmes fins, effectués par ces sites. Les utilisateurs du site
                            Internet de l'éditeur ne peuvent en aucun cas mettre en place un lien hypertexte en direction
                            du site Internet de l'éditeur sans l'autorisation écrite et préalable de l'éditeur. Toute demande
                                        tendant à cette fin doit être adressée au webmaster du site.</p>

                    </div>

                </div>
                <div><a id="cRetour" className="cInvisible" href="#haut"> </a></div>
                <div className="sticky-footer">
                    <Footer />
                </div>
            </div>
        );
    }
}

export default Mentions;


